document.addEventListener('click', function (event) {
  // Look for a product card wrapper with a product URL
  const card = event.target.closest('.product-card-wrapper[data-product-url]');
  if (!card) return;

  // Don't hijack clicks on quick-add buttons or inside modals
  if (event.target.closest('.quick-add') || event.target.closest('.quick-add-modal')) {
    return;
  }

  const url = card.getAttribute('data-product-url');
  if (!url) return;

  // If the direct click was on a normal link, let it behave as-is
  const directLink = event.target.closest('a');
  if (directLink && directLink.getAttribute('href')) {
    return;
  }

  window.location.href = url;
});
